import SearchIcon from "@mui/icons-material/Search";
import { TextField } from "@mui/material";
import { ClearIcon } from "@mui/x-date-pickers";
import React, { useContext, useRef, useState } from "react";

import useText from "../../hooks/use-text";
import { CollectionsContext } from "../../providers/collections-provider";
import { LocalizedStrings, SupportedLanguages } from "../../utils/lang";

export default function CollectionsSearchbar(): React.ReactElement {
  const { search, setSearch } = useContext(CollectionsContext);
  const [canClear, setCanClear] = useState<boolean>(false);
  const { strings } = useText(local);

  const ref = useRef<HTMLInputElement>();
  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>): void => {
    const value = event.target.value;

    setSearch(value);

    if (!!value || !canClear) {
      setCanClear(true);
    } else if (!value || canClear) {
      setCanClear(false);
    }
  };

  function handleClear(): void {
    if (!canClear) {
      return;
    }

    if (ref.current) {
      ref.current.value = "";
    }
    setCanClear(false);
    setSearch(undefined);
  }

  return (
    <div className="relative w-full">
      <label className="absolute text-[12px] top-[7px] left-[15px] text-slate-500 z-10">
        {strings.label}
      </label>
      <TextField
        inputRef={ref}
        className="shadow border-0 rounded-[15px] bg-white w-full"
        value={search}
        placeholder={strings.placeholder}
        onChange={handleSearch}
        sx={{
          "& .MuiInputBase-input": { paddingTop: "24px", paddingBottom: "9px" },
          ".MuiOutlinedInput-notchedOutline": {
            border: 0,
            borderRadius: "15px",
          },
        }}
        InputProps={{
          onClick: handleClear,
          endAdornment: !canClear ? (
            <SearchIcon className="text-[22px] text-slate-400" />
          ) : (
            <ClearIcon className="text-[22px] text-slate-400 cursor-pointer" />
          ),
        }}
      />
    </div>
  );
}

type LocalSchema = {
  label: string;
  placeholder: string;
};

const local: LocalizedStrings<LocalSchema, SupportedLanguages> = {
  default: {
    label: "Collections",
    placeholder: "Search in collections",
  },
};
